import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppGeneralsModuleslModule } from '../../../app-generals-modules.module';
import { AppMaterialModule } from '../../../app-material.module';
import { AuthService } from '../../../shared/services/auth.service';
import { ClienteService } from '../../../shared/services/cliente/cliente.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiResult } from '../../../shared/models/api-result.models';
import { AuthRightColumnComponent } from '../../../shared/components/auth-right-column/auth-right-column.component';
import { LanguageToggleComponent } from '../../../shared/components/language-toggle/language-toggle.component';
import { ThemeSwitcherComponent } from '../../../shared/components/theme-switcher/theme-switcher.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from '../../../shared/services/theme.service';
import { HttpErrorResponse } from '@angular/common/http';
import { buildHubLoginUrlWithReturn } from '../../../shared/utils/hub-redirect';

@Component({
    selector: 'app-recuperar-senha',
    standalone: true,
    imports: [
        CommonModule,
        AppGeneralsModuleslModule,
        AppMaterialModule,
        AuthRightColumnComponent,
        LanguageToggleComponent,
        ThemeSwitcherComponent,
        TranslocoPipe,
    ],
    providers: [AuthService, ClienteService],
    templateUrl: './recuperar-senha.component.html',
    styleUrl: './recuperar-senha.component.scss',
})
export class RecuperarSenhaComponent {
    public form: FormGroup = new FormGroup({});
    public enviado = false;

    public get hubLoginUrl(): string {
        if (typeof window === 'undefined') {
            return '';
        }
        return buildHubLoginUrlWithReturn(`${window.location.origin}/v2`);
    }

    constructor(
        private formBuilder: FormBuilder,
        private clienteService: ClienteService,
        private toastrService: ToastrService,
        private transloco: TranslocoService,
        public themeService: ThemeService,
    ) {
        this.form = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    public salvar() {
        if (this.form.invalid) {
            this.toastrService.error(this.transloco.translate('auth.recuperarSenha.validateField'));
            return;
        }

        const request = {
            email: this.form.get('email')?.value,
        };

        this.clienteService.recuperarSenha(request).subscribe({
            next: (apiResult: ApiResult) => {
                this.enviado = true;
            },
            error: (error: HttpErrorResponse) => {
                this.toastrService.error(error.error.message);
            },
        });
    }
}
